/**
 * CWSカテゴリ変換マスタ一覧出力画面Input用VOクラス
 */
export class KYMW6802InputModel {
  /**
   * カテゴリ区分
   */
  public categoryDiv: string = <string>'';
  /**
   * カテゴリコード
   */
  public categoryCode: string = <string>'';
}
